import React from "react"
import types from "prop-types"
import { taskShape } from "utils/propTypeShapes"
import { TASK_FORM_DELETED_QUESTIONS_NOTE, taskAnswerValues } from "utils/taskHelpers"
import { AnsweredFormOverview } from "shared/form"

const TaskCompletedTaskForm = ({ task, taskControls }) => {
  const { answers, subform } = task
  const { deletedQuestions = [], sections } = subform

  const answerValues = taskAnswerValues(answers)

  return (
    <AnsweredFormOverview
      answers={answerValues}
      deletedQuestionsNote={TASK_FORM_DELETED_QUESTIONS_NOTE}
      deletedQuestions={deletedQuestions}
      postSectionsContent={taskControls}
      sections={sections}
    />
  )
}

TaskCompletedTaskForm.propTypes = {
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskCompletedTaskForm
